/**
 * @generated SignedSource<<958f55a6e688b96a4d34f006c0cc1e5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AnalysisSimulationViewScenariosQuery$variables = Record<PropertyKey, never>;
export type AnalysisSimulationViewScenariosQuery$data = {
  readonly priceSimulationScenarios: ReadonlyArray<{
    readonly createdAt: any;
    readonly id: string;
    readonly name: string;
    readonly overrides: ReadonlyArray<{
      readonly daily: number | null | undefined;
      readonly hourly: number | null | undefined;
      readonly monthly: number | null | undefined;
      readonly monthlyCap: number | null | undefined;
      readonly outboundNetworkTransferPerGigabyte: number | null | undefined;
      readonly percentagePerProject: number | null | undefined;
      readonly pricePerUnit: number | null | undefined;
      readonly sku: string;
    }>;
  }>;
};
export type AnalysisSimulationViewScenariosQuery = {
  response: AnalysisSimulationViewScenariosQuery$data;
  variables: AnalysisSimulationViewScenariosQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PriceSimulationScenario",
    "kind": "LinkedField",
    "name": "priceSimulationScenarios",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PriceOverride",
        "kind": "LinkedField",
        "name": "overrides",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sku",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "monthly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hourly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "daily",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "monthlyCap",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentagePerProject",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "outboundNetworkTransferPerGigabyte",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pricePerUnit",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisSimulationViewScenariosQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AnalysisSimulationViewScenariosQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "0042c5ab1703c98d3001a7ebb59ac103",
    "id": null,
    "metadata": {},
    "name": "AnalysisSimulationViewScenariosQuery",
    "operationKind": "query",
    "text": "query AnalysisSimulationViewScenariosQuery {\n  priceSimulationScenarios {\n    id\n    name\n    createdAt\n    overrides {\n      sku\n      monthly\n      hourly\n      daily\n      monthlyCap\n      percentagePerProject\n      outboundNetworkTransferPerGigabyte\n      pricePerUnit\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "21a0d3a0b79594b07766100314334486";

export default node;
